import { useSelector } from '../../../react-redux';
import visitorSelector from '../selector';

const { parseVisitor, getFilterParam } = visitorSelector;

function filterBySource(data) {
  return data.filter(d => !d.sourceInfo || d.sourceInfo.source !== 'openCenter'); // 不要 开放平台 的对话
}

const useVisitorData = () => {
  const sourceVisitors = useSelector(state => parseVisitor(state.getIn(['visitor', 'visitorList']))) || [];
  const visitors = filterBySource(sourceVisitors);
  const visitorCondition = useSelector(state => state.getIn(['visitor', 'visitorCondition']));
  const onlineCount = useSelector(state => state.getIn(['visitor', 'onlineCount']));

  const filterCondition = getFilterParam(visitors);

  return {
    visitors,
    visitorCondition,
    filterCondition,
    onlineCount
  };
};

export default useVisitorData;
